<template>
    <modal :modal-id="modalId"
                     :title="modalTitle"
                     :preloader="preloader"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `crud/${inputs.id}` : `crud`'>
                <div class="form-group row align-items-center">
                    <label for="inputs_name" class="col-sm-3 mb-0">
                        {{ $t('title') }}
                    </label>
                    <app-input id="inputs_name"
                               class="col-sm-9"
                               type="text"
                               v-model="inputs.title"
                               :required="true"/>

                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('location') }}
                    </label>
                    <app-input id="inputs_name"
                               class="col-sm-9"
                               type="text"
                               v-model="inputs.location"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('job_type') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.job_type"
                               :list="jobTypeList"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('published') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.published"
                               :list="publishedList"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t('description') }}
                    </label>
                    <app-input id="inputs_email"
                               class="col-sm-9"
                               type="textarea"
                               v-model="inputs.description"
                               :required="true"/>
                </div>
                
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin'
    import {ModalMixin} from "../../../../../../app/Mixins/ModalMixin";
import { axiosPost } from '../../../../../Helpers/AxiosHelper';
import { COMPANY_JOB_STORE, COMPANY_JOB_UPDATE } from '../../../../../Config/ApiUrl';

    export default {
        name: "AddModal",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String
        },
        data() {
            return {
                preloader: false,
                inputs: {
                },
                jobTypeList: [
                    {id: '', value: "Choose One",},
                    {id: 'On-site', value: "On-site"},
                    {id: 'Hybrid', value: "Hybrid"},
                    {id: 'Remote', value: "Remote"},
                ],
                publishedList: [
                    {id: '', value: "Choose One",},
                    {id: '1', value: "Published"},
                    {id: '0', value: "Diraft"},
                ],
                modalId: 'demo-add-edit-Modal',
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                // this.inputs.phone = this.phone;
                // this.save(this.inputs);
                if (this.modalTitle == 'Edit') {
                    axiosPost(COMPANY_JOB_UPDATE, this.inputs)
                        .then(res => {
                            
                            // this.modalId = false;
                            this.$toastr.s(res.data.message);
                            this.$hub.$emit('reload-' + this.tableId);
                        })
                        .catch (error => {
                            
                        });
                } else {
                    axiosPost(COMPANY_JOB_STORE, this.inputs)
                    .then((res) => {
                        
                    })
                    .catch((error) => {
                        
                    });
                }
                
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                this.inputs = response.data;
                this.preloader = false;
            },
        },
    }
</script>
